import { render, staticRenderFns } from "./SignalAndMessage.vue?vue&type=template&id=68c25afe"
import script from "./SignalAndMessage.vue?vue&type=script&lang=js"
export * from "./SignalAndMessage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports